// // import React from 'react';
// // import './seamless_onboard.css';
// // import leftImage from "../../img/des_sec/seam_card_Left.svg"
// // import card1 from "../../img/des_sec/seam_card_1.svg"
// // import card2 from "../../img/des_sec/seam_card_2.svg"
// // import card3 from "../../img/des_sec/seam_card_3.svg"

// // const ReferralPartners = () => {
// //   return (
// //     <div className="onboarding-container-rp">
// //          <div className="blue-header-rp">
// //         <h1>Features</h1>
// //       </div>
// //       {/* Background image (half flex design) */}
// //       <div className="background-image-rp"></div>
      
// //       <div className="content-wrapper-rp">
// //         {/* Left side - single illustration image */}
// //         <div className="left-illustration-rp">
// //           <img src={leftImage} alt="Onboarding Illustration" />
// //         </div>
        
// //         {/* Right side content */}
// //         <div className="right-content-rp">
// //           {/* Title */}
// //           <h1 className="title-rp">Seamless Onboarding</h1>
          
// //           {/* Three card images stacked vertically */}
// //           <div className="cards-stack-rp">
// //             <img src={card1} alt="Instant Aadhaar Verification" className="feature-card-rp" />
// //             <img src={card2} alt="Customizable Approval Workflows" className="feature-card-rp" />
// //             <img src={card3} alt="Integrated Agency Management" className="feature-card-rp" />
// //           </div>
          
          
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ReferralPartners;

// // import React from 'react';
// // import './seamless_onboard.css';
// // import leftImage from "../../img/des_sec/Seamless Onboarding.svg"
// // import card1 from "../../img/des_sec/seam_card_1.svg"
// // import card2 from "../../img/des_sec/seam_card_2.svg"
// // import card3 from "../../img/des_sec/seam_card_3.svg"
// // import { useRef } from 'react';

// // const ReferralPartners = () => {
// //   const sliderRef = useRef(null);

// //   const scrollLeft = () => {
// //     if (sliderRef.current) {
// //       sliderRef.current.scrollBy({ left: -200, behavior: 'smooth' });
// //     }
// //   };

// //   const scrollRight = () => {
// //     if (sliderRef.current) {
// //       sliderRef.current.scrollBy({ left: 200, behavior: 'smooth' });
// //     }
// //   };

// //   return (
// //     <div className="onboarding-container-rp">
// //       <div className="blue-header-rp">
// //         <h1>Features</h1>
// //       </div>
      
// //       <div className="background-image-rp"></div>
      
// //       <div className="content-wrapper-rp">
// //         {/* Mobile title comes first */}
// //         <h1 className="title-rp mobile-title">Seamless Onboarding</h1>
        
// //         {/* Left illustration */}
// //         <div className="left-illustration-rp">
// //           <img src={leftImage} alt="Onboarding Illustration" />
// //         </div>
        
// //         {/* Right content */}
// //         <div className="right-content-rp">
// //           {/* Desktop title (hidden on mobile) */}
// //           <h1 className="title-rp desktop-title">Seamless Onboarding</h1>
          
// //           {/* Cards slider container */}
// //           <div className="cards-slider-container">
// //             <button className="slider-arrow left-arrow" onClick={scrollLeft}>&lt;</button>
            
// //             {/* Cards stack with slider functionality */}
// //             <div className="cards-stack-rp" ref={sliderRef}>
// //               <img src={card1} alt="Instant Aadhaar Verification" className="feature-card-rp" />
// //               <img src={card2} alt="Customizable Approval Workflows" className="feature-card-rp" />
// //               <img src={card3} alt="Integrated Agency Management" className="feature-card-rp" />
// //             </div>
            
// //             <button className="slider-arrow right-arrow" onClick={scrollRight}>&gt;</button>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ReferralPartners;


// // import React, { useRef, useEffect, useState } from 'react';
// // import { useSpring, animated } from 'react-spring';
// // import './referral_partners.css';
// // import card1 from "../../img/des_sec/rp_1.svg"
// // import card2 from "../../img/des_sec/rp_2.svg"
// // import card3 from "../../img/des_sec/rp_3.svg"

// // const ReferralPartners = () => {
// //   const [inView, setInView] = useState(false);
// //   const containerRef = useRef(null);
// //   const sliderRef = useRef(null);

// //   useEffect(() => {
// //     const observer = new IntersectionObserver(
// //       ([entry]) => {
// //         if (entry.isIntersecting) {
// //           setInView(true);
// //         } else {
// //           setInView(false);
// //         }
// //       },
// //       {
// //         threshold: 0.2,
// //         rootMargin: '-50px 0px'
// //       }
// //     );

// //     if (containerRef.current) {
// //       observer.observe(containerRef.current);
// //     }

// //     return () => {
// //       if (containerRef.current) {
// //         observer.unobserve(containerRef.current);
// //       }
// //     };
// //   }, []);

// //   const scrollLeft = () => {
// //     if (sliderRef.current) {
// //       sliderRef.current.scrollBy({ left: -200, behavior: 'smooth' });
// //     }
// //   };

// //   const scrollRight = () => {
// //     if (sliderRef.current) {
// //       sliderRef.current.scrollBy({ left: 200, behavior: 'smooth' });
// //     }
// //   };

// //   // Animation for blue header
// //   const blueHeaderAnimation = useSpring({
// //     opacity: inView ? 1 : 0,
// //     transform: inView ? 'translateY(0px)' : 'translateY(-15px)',
// //     config: { 
// //       tension: 200, 
// //       friction: 40,
// //       mass: 1
// //     },
// //     delay: inView ? 100 : 0
// //   });

// //   // Animation for mobile title
// //   const mobileTitleAnimation = useSpring({
// //     opacity: inView ? 1 : 0,
// //     transform: inView ? 'translateY(0px)' : 'translateY(20px)',
// //     config: { 
// //       tension: 180, 
// //       friction: 35,
// //       mass: 1
// //     },
// //     delay: inView ? 200 : 0
// //   });

// //   // Animation for left illustration
// //   const leftIllustrationAnimation = useSpring({
// //     opacity: inView ? 1 : 0,
// //     transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-30px) scale(0.95)',
// //     config: { 
// //       tension: 160, 
// //       friction: 30,
// //       mass: 1.2
// //     },
// //     delay: inView ? 300 : 0
// //   });

// //   // Animation for desktop title
// //   const desktopTitleAnimation = useSpring({
// //     opacity: inView ? 1 : 0,
// //     transform: inView ? 'translateY(0px)' : 'translateY(20px)',
// //     config: { 
// //       tension: 180, 
// //       friction: 35,
// //       mass: 1
// //     },
// //     delay: inView ? 400 : 0
// //   });

// //   // Animation for left arrow
// //   const leftArrowAnimation = useSpring({
// //     opacity: inView ? 1 : 0,
// //     transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-10px) scale(0.9)',
// //     config: { 
// //       tension: 150, 
// //       friction: 25,
// //       mass: 0.8
// //     },
// //     delay: inView ? 500 : 0
// //   });

// //   // Animation for right arrow
// //   const rightArrowAnimation = useSpring({
// //     opacity: inView ? 1 : 0,
// //     transform: inView ? 'translateX(0px) scale(1)' : 'translateX(10px) scale(0.9)',
// //     config: { 
// //       tension: 150, 
// //       friction: 25,
// //       mass: 0.8
// //     },
// //     delay: inView ? 500 : 0
// //   });

// //   // Individual card animations with staggered delays
// //   const card1Animation = useSpring({
// //     opacity: inView ? 1 : 0,
// //     transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
// //     config: { 
// //       tension: 140, 
// //       friction: 25,
// //       mass: 0.9
// //     },
// //     delay: inView ? 600 : 0
// //   });

// //   const card2Animation = useSpring({
// //     opacity: inView ? 1 : 0,
// //     transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
// //     config: { 
// //       tension: 140, 
// //       friction: 25,
// //       mass: 0.9
// //     },
// //     delay: inView ? 750 : 0
// //   });

// //   const card3Animation = useSpring({
// //     opacity: inView ? 1 : 0,
// //     transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
// //     config: { 
// //       tension: 140, 
// //       friction: 25,
// //       mass: 0.9
// //     },
// //     delay: inView ? 900 : 0
// //   });

// //   return (
// //     <div className="onboarding-container-rp" ref={containerRef}>
// //       <animated.div 
// //         className="blue-header-rp"
// //         style={{
// //           ...blueHeaderAnimation,
// //           position: 'relative',
// //           zIndex: 1
// //         }}
// //       >
// //         <h1>Features</h1>
// //       </animated.div>
      
// //       <div className="background-image-rp"></div>
      
// //       <div className="content-wrapper-rp">
// //         {/* Mobile title comes first */}
// //         <animated.h1 
// //           className="title-rp mobile-title"
// //           style={{
// //             ...mobileTitleAnimation,
// //             position: 'relative',
// //             zIndex: 1
// //           }}
// //         >
// //           Seamless Onboarding
// //         </animated.h1>
        
       
        
// //         {/* Right content */}
// //         <div className="right-content-rp">
// //           {/* Desktop title (hidden on mobile) */}
// //           <animated.h1 
// //             className="title-rp desktop-title"
// //             style={{
// //               ...desktopTitleAnimation,
// //               position: 'relative',
// //               zIndex: 1
// //             }}
// //           >
// //             Seamless Onboarding
// //           </animated.h1>
          
// //           {/* Cards slider container */}
// //           <div className="cards-slider-container">
// //             <animated.button 
// //               className="slider-arrow left-arrow" 
// //               onClick={scrollLeft}
// //               style={{
// //                 ...leftArrowAnimation,
// //                 position: 'relative',
// //                 zIndex: 1
// //               }}
// //             >
// //               &lt;
// //             </animated.button>
            
// //             {/* Cards stack with slider functionality */}
// //             <div className="cards-stack-rp" ref={sliderRef}>
// //               <animated.img 
// //                 src={card1} 
// //                 alt="Instant Aadhaar Verification" 
// //                 className="feature-card-rp"
// //                 style={{
// //                   ...card1Animation,
// //                   position: 'relative',
// //                   zIndex: 1
// //                 }}
// //               />
// //               <animated.img 
// //                 src={card2} 
// //                 alt="Customizable Approval Workflows" 
// //                 className="feature-card-rp"
// //                 style={{
// //                   ...card2Animation,
// //                   position: 'relative',
// //                   zIndex: 1
// //                 }}
// //               />
// //               <animated.img 
// //                 src={card3} 
// //                 alt="Integrated Agency Management" 
// //                 className="feature-card-rp"
// //                 style={{
// //                   ...card3Animation,
// //                   position: 'relative',
// //                   zIndex: 1
// //                 }}
// //               />
// //             </div>
            
// //             <animated.button 
// //               className="slider-arrow right-arrow" 
// //               onClick={scrollRight}
// //               style={{
// //                 ...rightArrowAnimation,
// //                 position: 'relative',
// //                 zIndex: 1
// //               }}
// //             >
// //               &gt;
// //             </animated.button>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ReferralPartners;

// import React, { useRef, useEffect, useState } from 'react';
// import { useSpring, animated } from 'react-spring';

// const ReferralPartners = () => {
//   const [inView, setInView] = useState(false);
//   const containerRef = useRef(null);
//   const sliderRef = useRef(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setInView(true);
//         } else {
//           setInView(false);
//         }
//       },
//       {
//         threshold: 0.2,
//         rootMargin: '-50px 0px'
//       }
//     );

//     if (containerRef.current) {
//       observer.observe(containerRef.current);
//     }

//     return () => {
//       if (containerRef.current) {
//         observer.unobserve(containerRef.current);
//       }
//     };
//   }, []);

//   const scrollLeft = () => {
//     if (sliderRef.current) {
//       sliderRef.current.scrollBy({ left: -280, behavior: 'smooth' });
//     }
//   };

//   const scrollRight = () => {
//     if (sliderRef.current) {
//       sliderRef.current.scrollBy({ left: 280, behavior: 'smooth' });
//     }
//   };

//   // Animation configurations
//   const blueHeaderAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(-15px)',
//     config: { tension: 200, friction: 40, mass: 1 },
//     delay: inView ? 100 : 0
//   });

//   const mobileTitleAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(20px)',
//     config: { tension: 180, friction: 35, mass: 1 },
//     delay: inView ? 200 : 0
//   });

//   const leftIllustrationAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-30px) scale(0.95)',
//     config: { tension: 160, friction: 30, mass: 1.2 },
//     delay: inView ? 300 : 0
//   });

//   const desktopTitleAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(20px)',
//     config: { tension: 180, friction: 35, mass: 1 },
//     delay: inView ? 400 : 0
//   });

//   const leftArrowAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-10px) scale(0.9)',
//     config: { tension: 150, friction: 25, mass: 0.8 },
//     delay: inView ? 500 : 0
//   });

//   const rightArrowAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px) scale(1)' : 'translateX(10px) scale(0.9)',
//     config: { tension: 150, friction: 25, mass: 0.8 },
//     delay: inView ? 500 : 0
//   });

//   const card1Animation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
//     config: { tension: 140, friction: 25, mass: 0.9 },
//     delay: inView ? 600 : 0
//   });

//   const card2Animation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
//     config: { tension: 140, friction: 25, mass: 0.9 },
//     delay: inView ? 750 : 0
//   });

//   const card3Animation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
//     config: { tension: 140, friction: 25, mass: 0.9 },
//     delay: inView ? 900 : 0
//   });

//   // Card data
//   const cardData = [
//     {
//       title: "REFERRAL PARTNER",
//       percentage: "8%",
//       subtitle: "Recurring Income",
//       bulletPoints: [
//         "You refer leads; VYN manages sales and implementation",
//         "ZERO investment required",
//         "Ideal for: Consultants, Industry Experts, Network Connectors"
//       ]
//     },
//     {
//       title: "SALES PARTNER",
//       percentage: "20% +",
//       subtitle: "Recurring Income",
//       bulletPoints: [
//         "You generate leads and close sales; VYN handles implementation",
//         "Perfect for: Consultancy Firms, IT Resellers",
//       ]
//     },
//     {
//       title: "IMPLEMENTATION PARTNER",
//       percentage: "30% +",
//       subtitle: "Recurring Income",
//       bulletPoints: [
//         "You implement VYN for your clients with full support from us",
//         "Perfect for: IT Service Providers, Workforce Tech Specialists",
//       ]
//     }
//   ];

//   return (
//     <div style={{ position: 'relative', width: '100%', overflow: 'hidden' }} ref={containerRef}>
//       <animated.div 
//         style={{
//           ...blueHeaderAnimation,
//           position: 'relative',
//           zIndex: 1,
//           width: '100%',
//           backgroundColor: 'white',
//           fontSize: '18px',
//           color: '#04426B',
//           textAlign: 'center',
//           padding: '1.5rem 0',
//           boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)'
//         }}
//       >
//         <h1 style={{ margin: 0, fontSize: '28px', fontWeight: 600 }}>Partner Model</h1>
//       </animated.div>
      
//       <div style={{
//         position: 'absolute',
//         left: 0,
//         width: '100%',
//         height: '50%',
//         background: 'linear-gradient(135deg, #096BAA 0%, #06436B 100%)',
//         zIndex: -1
//       }}></div>
      
//       <div style={{
//         display: 'flex',
//         margin: '0 20px',
//         padding: '40px 40px',
//         gap: '60px',
//         alignItems: 'center',
//         '@media (max-width: 768px)': {
//           flexDirection: 'column',
//           padding: '40px 15px',
//           gap: '40px'
//         }
//       }}>
//         {/* Mobile title */}
//         <animated.h1 
//           style={{
//             ...mobileTitleAnimation,
//             position: 'relative',
//             zIndex: 1,
//             fontSize: '1.5rem',
//             color: 'white',
//             marginBottom: '0px',
//             fontWeight: 500,
//             textAlign: 'center',
//             display: 'none',
//             '@media (max-width: 768px)': {
//               display: 'block',
//               order: -1,
//               width: '100%'
//             }
//           }}
//         >
//           Unlock Continuous Earnings with VYN’s Recurring Revenue Program
//         </animated.h1>
//         <animated.h1 
//           style={{
//             ...mobileTitleAnimation,
//             position: 'relative',
//             zIndex: 1,
//             fontSize: '1rem',
//             color: 'white',
//             marginBottom: '0px',
//             fontWeight: 400,
//             textAlign: 'center',
//             display: 'none',
//             '@media (max-width: 768px)': {
//               display: 'block',
//               order: -1,
//               width: '100%'
//             }
//           }}
//         >
//           Unlock Continuous Earnings with VYN’s Recurring Revenue Program
//         </animated.h1>
        
//         {/* Right content */}
//         <div style={{ flex: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//           {/* Desktop title */}
//           <animated.h1 
//             style={{
//               ...desktopTitleAnimation,
//               position: 'relative',
//               zIndex: 1,
//               fontSize: '1.2rem',
//               color: 'white',
//               // marginBottom: '40px',
//               fontWeight: 500,
//               '@media (max-width: 768px)': {
//                 display: 'none'
//               }
//             }}
//           >
//             Unlock Continuous Earnings with VYN’s Recurring Revenue Program
//           </animated.h1>
//           <animated.h1 
//             style={{
//               ...desktopTitleAnimation,
//               position: 'relative',
//               zIndex: 1,
//               fontSize: '1rem',textAlign:"center",opacity:0.8,
//               color: 'white',
//               marginBottom: '40px',
//               fontWeight: 500,
//               '@media (max-width: 768px)': {
//                 display: 'none'
//               }
//             }}
//           >
//             Expand your reach and revenue by collaborating with VYN. Choose the partnership model that fits your strengths—whether it’s referring, selling, or implementing—and start earning sustainable, predictable income.
//           </animated.h1>
          
//           {/* Cards slider container */}
//           <div style={{ position: 'relative', width: '100%' }}>
//             <animated.button 
//               onClick={scrollLeft}
//               style={{
//                 ...leftArrowAnimation,
//                 position: 'absolute',
//                 top: '50%',
//                 transform: 'translateY(-50%)',
//                 left: '10px',
//                 width: '40px',
//                 height: '40px',
//                 backgroundColor: 'rgba(255, 255, 255, 0.8)',
//                 border: '1px solid #ddd',
//                 borderRadius: '50%',
//                 fontSize: '1.2rem',
//                 cursor: 'pointer',
//                 zIndex: 10,
//                 display: 'none',
//                 '@media (max-width: 768px)': {
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }
//               }}
//             >
//               &lt;
//             </animated.button>
            
//             {/* Cards stack */}
//             <div 
//               ref={sliderRef}
//               style={{
//                 display: 'flex',
//                 gap: '15px',
//                 '@media (max-width: 768px)': {
//                   overflowX: 'auto',
//                   scrollSnapType: 'x mandatory',
//                   gap: '10px',
//                   WebkitOverflowScrolling: 'touch',
//                   scrollbarWidth: 'none'
//                 }
//               }}
//             >
//               {/* Card 1 */}
//               <animated.div 
//                 style={{
//                   ...card1Animation,
//                   position: 'relative',
//                   zIndex: 1
//                 }}
//               >
//                 <div style={{
//                   backgroundColor: 'white',
//                   borderRadius: '12px',
//                   padding: '24px',
//                   minWidth: '280px',
//                   height: '480px',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
//                   cursor: 'pointer',
//                   transition: 'transform 0.3s ease-in-out',
//                   border: '1px solid #e5e7eb',borderTop: '10px solid #1FE16F'
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'scale(1.05)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'scale(1)';
//                 }}
//                 >
//                   <div style={{
//                     textAlign: 'center',
//                     borderBottom: '1px solid #e5e7eb',
//                     paddingBottom: '16px',
//                     marginBottom: '0px'
//                   }}>
//                     <h3 style={{
//                       fontSize: '18px',
//                       fontWeight: 600,
//                       color: '#374151',
//                       margin: '0 0 12px 0',
//                       letterSpacing: '0.5px'
//                     }}>
//                       {cardData[0].title}
//                     </h3>
//                     <div style={{
//   fontSize: '65px',
//   fontWeight: 700,
//   margin: '8px 0',
//   lineHeight: '1',
//   background: 'linear-gradient(to right, #064771, #328CC9)',
//   WebkitBackgroundClip: 'text',
//   backgroundClip: 'text',
//   color: 'transparent',
// }}>
//                       {cardData[0].percentage}
//                     </div>
//                     <h4 style={{
//                       fontSize: '18px',
//                       fontWeight: 600,
//                       color: '#1f2937',
//                       margin: '8px 0 0 0'
//                     }}>
//                       {cardData[0].subtitle}
//                     </h4>
//                   </div>
                  
//                   <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
//                     <ul style={{
//                       listStyle: 'none',
//                       padding: 0,
//                       margin: '0 0 0px 0',
//                       flex: 1
//                     }}>
//                       {cardData[0].bulletPoints.map((point, index) => (
//                         <li key={index} style={{
//                           display: 'flex',
//                           alignItems: 'flex-start',
//                           marginBottom: '12px',
//                           fontSize: '14px',
//                           color: '#000000',
//                           lineHeight: '1.5'
//                         }}>
//                           <span style={{
//                             color: '#8b5cf6',
//                             marginRight: '8px',
//                             fontSize: '16px',
//                             fontWeight: 'bold',
//                             marginTop: '2px'
//                           }}>▶</span>
//                           {point}
//                         </li>
//                       ))}
//                     </ul>
                    
//                     <button style={{
//                       backgroundColor: 'transparent',
//                       color: '#064771',
//                       border: '2px solid #064771',
//                       borderRadius: '6px',
//                       padding: '12px 24px',
//                       fontSize: '16px',
//                       fontWeight: 600,
//                       cursor: 'pointer',
//                       transition: 'all 0.3s ease',
//                       width: '100%',
//                       marginTop: 'auto'
//                     }}
//                     onMouseEnter={(e) => {
//                       e.target.style.backgroundColor = '#064771';
//                       e.target.style.color = 'white';
//                     }}
//                     onMouseLeave={(e) => {
//                       e.target.style.backgroundColor = 'transparent';
//                       e.target.style.color = '#064771';
//                     }}
//                     >
//                       Join Now
//                     </button>
//                   </div>
//                 </div>
//               </animated.div>

//               {/* Card 2 */}
//               <animated.div 
//                 style={{
//                   ...card2Animation,
//                   position: 'relative',
//                   zIndex: 1
//                 }}
//               >
//                 <div style={{
//                   backgroundColor: 'white',
//                   borderRadius: '12px',
//                   padding: '24px',
//                   minWidth: '280px',
//                   height: '480px',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
//                   cursor: 'pointer',
//                   transition: 'transform 0.3s ease-in-out',
//                   border: '1px solid #e5e7eb',borderTop: '10px solid #1FE16F'
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'scale(1.05)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'scale(1)';
//                 }}
//                 >
//                   <div style={{
//                     textAlign: 'center',
//                     borderBottom: '1px solid #e5e7eb',
//                     paddingBottom: '16px',
//                     marginBottom: '0px'
//                   }}>
//                     <h3 style={{
//                       fontSize: '18px',
//                       fontWeight: 600,
//                       color: '#374151',
//                       margin: '0 0 12px 0',
//                       letterSpacing: '0.5px'
//                     }}>
//                       {cardData[1].title}
//                     </h3>
//                     <div style={{
//   fontSize: '65px',
//   fontWeight: 700,
//   margin: '8px 0',
//   lineHeight: '1',
//   background: 'linear-gradient(to right, #064771, #328CC9)',
//   WebkitBackgroundClip: 'text',
//   backgroundClip: 'text',
//   color: 'transparent',
// }}>
//                       {cardData[1].percentage}
//                     </div>
//                     <h4 style={{
//                       fontSize: '18px',
//                       fontWeight: 600,
//                       color: '#1f2937',
//                       margin: '8px 0 0 0'
//                     }}>
//                       {cardData[1].subtitle}
//                     </h4>
//                   </div>
                  
//                   <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
//                     <ul style={{
//                       listStyle: 'none',
//                       padding: 0,
//                       margin: '0 0 0px 0',
//                       flex: 1
//                     }}>
//                       {cardData[1].bulletPoints.map((point, index) => (
//                         <li key={index} style={{
//                           display: 'flex',
//                           alignItems: 'flex-start',
//                           marginBottom: '12px',
//                           fontSize: '14px',
//                           color: '#000000',
//                           lineHeight: '1.5'
//                         }}>
//                           <span style={{
//                             color: '#8b5cf6',
//                             marginRight: '8px',
//                             fontSize: '16px',
//                             fontWeight: 'bold',
//                             marginTop: '2px'
//                           }}>▶</span>
//                           {point}
//                         </li>
//                       ))}
//                     </ul>
                    
//                     <button style={{
//                       backgroundColor: 'transparent',
//                       color: '#064771',
//                       border: '2px solid #064771',
//                       borderRadius: '6px',
//                       padding: '12px 24px',
//                       fontSize: '16px',
//                       fontWeight: 600,
//                       cursor: 'pointer',
//                       transition: 'all 0.3s ease',
//                       width: '100%',
//                       marginTop: 'auto'
//                     }}
//                     onMouseEnter={(e) => {
//                       e.target.style.backgroundColor = '#064771';
//                       e.target.style.color = 'white';
//                     }}
//                     onMouseLeave={(e) => {
//                       e.target.style.backgroundColor = 'transparent';
//                       e.target.style.color = '#064771';
//                     }}
//                     >
//                       Join Now
//                     </button>
//                   </div>
//                 </div>
//               </animated.div>

//               {/* Card 3 */}
//               <animated.div 
//                 style={{
//                   ...card3Animation,
//                   position: 'relative',
//                   zIndex: 1
//                 }}
//               >
//                 <div style={{
//                   backgroundColor: 'white',
//                   borderRadius: '12px',
//                   padding: '24px',
//                   minWidth: '280px',
//                   height: '480px',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
//                   cursor: 'pointer',
//                   transition: 'transform 0.3s ease-in-out',
//                   border: '1px solid #e5e7eb',borderTop: '10px solid #1FE16F'
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'scale(1.05)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'scale(1)';
//                 }}
//                 >
//                   <div style={{
//                     textAlign: 'center',
//                     borderBottom: '1px solid #e5e7eb',
//                     paddingBottom: '16px',
//                     marginBottom: '0px'
//                   }}>
//                     <h3 style={{
//                       fontSize: '18px',
//                       fontWeight: 600,
//                       color: '#374151',
//                       margin: '0 0 12px 0',
//                       letterSpacing: '0.5px'
//                     }}>
//                       {cardData[2].title}
//                     </h3>
//                     <div style={{
//   fontSize: '65px',
//   fontWeight: 700,
//   margin: '8px 0',
//   lineHeight: '1',
//   background: 'linear-gradient(to right, #064771, #328CC9)',
//   WebkitBackgroundClip: 'text',
//   backgroundClip: 'text',
//   color: 'transparent',
// }}>
//                       {cardData[2].percentage}
//                     </div>
//                     <h4 style={{
//                       fontSize: '18px',
//                       fontWeight: 600,
//                       color: '#1f2937',
//                       margin: '8px 0 0 0'
//                     }}>
//                       {cardData[2].subtitle}
//                     </h4>
//                   </div>
                  
//                   <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
//                     <ul style={{
//                       listStyle: 'none',
//                       padding: 0,
//                       margin: '0 0 0px 0',
//                       flex: 1
//                     }}>
//                       {cardData[2].bulletPoints.map((point, index) => (
//                         <li key={index} style={{
//                           display: 'flex',
//                           alignItems: 'flex-start',
//                           marginBottom: '12px',
//                           fontSize: '14px',
//                           color: '#000000',
//                           lineHeight: '1.5'
//                         }}>
//                           <span style={{
//                             color: '#8b5cf6',
//                             marginRight: '8px',
//                             fontSize: '16px',
//                             fontWeight: 'bold',
//                             marginTop: '2px'
//                           }}>▶</span>
//                           {point}
//                         </li>
//                       ))}
//                     </ul>
                    
//                     <button style={{
//                       backgroundColor: 'transparent',
//                       color: '#064771',
//                       border: '2px solid #064771',
//                       borderRadius: '6px',
//                       padding: '12px 24px',
//                       fontSize: '16px',
//                       fontWeight: 600,
//                       cursor: 'pointer',
//                       transition: 'all 0.3s ease',
//                       width: '100%',
//                       marginTop: 'auto'
//                     }}
//                     onMouseEnter={(e) => {
//                       e.target.style.backgroundColor = '#064771';
//                       e.target.style.color = 'white';
//                     }}
//                     onMouseLeave={(e) => {
//                       e.target.style.backgroundColor = 'transparent';
//                       e.target.style.color = '#064771';
//                     }}
//                     >
//                       Join Now
//                     </button>
//                   </div>
//                 </div>
//               </animated.div>
//             </div>
            
//             <animated.button 
//               onClick={scrollRight}
//               style={{
//                 ...rightArrowAnimation,
//                 position: 'absolute',
//                 top: '50%',
//                 transform: 'translateY(-50%)',
//                 right: '10px',
//                 width: '40px',
//                 height: '40px',
//                 backgroundColor: 'rgba(255, 255, 255, 0.8)',
//                 border: '1px solid #ddd',
//                 borderRadius: '50%',
//                 fontSize: '1.2rem',
//                 cursor: 'pointer',
//                 zIndex: 10,
//                 display: 'none',
//                 '@media (max-width: 768px)': {
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }
//               }}
//             >
//               &gt;
//             </animated.button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReferralPartners;

// import React, { useRef, useEffect, useState } from 'react';
// import { useSpring, animated } from 'react-spring';
// import img1 from "../../img/des_sec/partner_img_1.svg";
// import img2 from "../../img/des_sec/partner_img_2.svg";
// import img3 from "../../img/des_sec/partner_img_3.svg";
// import divider from "../../img/des_sec/divider_partner.svg";

// const ReferralPartners = () => {
//   const [inView, setInView] = useState(false);
//   const containerRef = useRef(null);
//   const sliderRef = useRef(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setInView(true);
//         } else {
//           setInView(false);
//         }
//       },
//       {
//         threshold: 0.2,
//         rootMargin: '-50px 0px'
//       }
//     );

//     if (containerRef.current) {
//       observer.observe(containerRef.current);
//     }

//     return () => {
//       if (containerRef.current) {
//         observer.unobserve(containerRef.current);
//       }
//     };
//   }, []);

//   const scrollLeft = () => {
//     if (sliderRef.current) {
//       sliderRef.current.scrollBy({ left: -280, behavior: 'smooth' });
//     }
//   };

//   const scrollRight = () => {
//     if (sliderRef.current) {
//       sliderRef.current.scrollBy({ left: 280, behavior: 'smooth' });
//     }
//   };

//   // Animation configurations
//   const blueHeaderAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(-15px)',
//     config: { tension: 200, friction: 40, mass: 1 },
//     delay: inView ? 100 : 0
//   });

//   const mobileTitleAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(20px)',
//     config: { tension: 180, friction: 35, mass: 1 },
//     delay: inView ? 200 : 0
//   });

//   const leftIllustrationAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-30px) scale(0.95)',
//     config: { tension: 160, friction: 30, mass: 1.2 },
//     delay: inView ? 300 : 0
//   });

//   const desktopTitleAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(20px)',
//     config: { tension: 180, friction: 35, mass: 1 },
//     delay: inView ? 400 : 0
//   });

//   const leftArrowAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-10px) scale(0.9)',
//     config: { tension: 150, friction: 25, mass: 0.8 },
//     delay: inView ? 500 : 0
//   });

//   const rightArrowAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px) scale(1)' : 'translateX(10px) scale(0.9)',
//     config: { tension: 150, friction: 25, mass: 0.8 },
//     delay: inView ? 500 : 0
//   });

//   const card1Animation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
//     config: { tension: 140, friction: 25, mass: 0.9 },
//     delay: inView ? 600 : 0
//   });

//   const card2Animation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
//     config: { tension: 140, friction: 25, mass: 0.9 },
//     delay: inView ? 750 : 0
//   });

//   const card3Animation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
//     config: { tension: 140, friction: 25, mass: 0.9 },
//     delay: inView ? 900 : 0
//   });

//   // Card data - Add your image paths here
//   const cardData = [
//     {
//       title: "REFERRAL PARTNER",
//       percentageImage: img1, // Replace with your image path
//       dividerImage: divider, // Replace with your divider image path
//       subtitle: "Recurring Income",
//       bulletPoints: [
//         "You refer leads; VYN manages sales and implementation",
//         "ZERO investment required",
//         "Ideal for: Consultants, Industry Experts, Network Connectors"
//       ]
//     },
//     {
//       title: "SALES PARTNER",
//       percentageImage: img2, // Replace with your image path
//       dividerImage: divider, // Replace with your divider image path
//       subtitle: "Recurring Income",
//       bulletPoints: [
//         "You generate leads and close sales; VYN handles implementation",
//         "Perfect for: Consultancy Firms, IT Resellers",
//       ]
//     },
//     {
//       title: "IMPLEMENTATION PARTNER",
//       percentageImage: img3, // Replace with your image path
//       dividerImage: divider, // Replace with your divider image path
//       subtitle: "Recurring Income",
//       bulletPoints: [
//         "You implement VYN for your clients with full support from us",
//         "Perfect for: IT Service Providers, Workforce Tech Specialists",
//       ]
//     }
//   ];

//   return (
//     <div style={{ position: 'relative', width: '100%', overflow: 'hidden' }} ref={containerRef}>
//       <animated.div 
//         style={{
//           ...blueHeaderAnimation,
//           position: 'relative',
//           zIndex: 1,
//           width: '100%',
//           backgroundColor: 'white',
//           fontSize: '18px',
//           color: '#04426B',
//           textAlign: 'center',
//           padding: '1.5rem 0',
//           boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)'
//         }}
//       >
//         <h1 style={{ margin: 0, fontSize: '28px', fontWeight: 600 }}>Partner Model</h1>
//       </animated.div>
      
//       <div style={{
//         position: 'absolute',
//         left: 0,
//         width: '100%',
//         height: '50%',
//         background: 'linear-gradient(135deg, #096BAA 0%, #06436B 100%)',
//         zIndex: -1
//       }}></div>
      
//       <div style={{
//         display: 'flex',
//         margin: '0 20px',
//         padding: '40px 40px',
//         gap: '60px',
//         alignItems: 'center',
//         '@media (max-width: 768px)': {
//           flexDirection: 'column',
//           padding: '40px 15px',
//           gap: '40px'
//         }
//       }}>
//         {/* Mobile title */}
//         <animated.h1 
//           style={{
//             ...mobileTitleAnimation,
//             position: 'relative',
//             zIndex: 1,
//             fontSize: '1.5rem',
//             color: 'white',
//             marginBottom: '0px',
//             fontWeight: 500,
//             textAlign: 'center',
//             display: 'none',
//             '@media (max-width: 768px)': {
//               display: 'block',
//               order: -1,
//               width: '100%'
//             }
//           }}
//         >
//           Unlock Continuous Earnings with VYN's Recurring Revenue Program
//         </animated.h1>
//         <animated.h1 
//           style={{
//             ...mobileTitleAnimation,
//             position: 'relative',
//             zIndex: 1,
//             fontSize: '1rem',
//             color: 'white',
//             marginBottom: '0px',
//             fontWeight: 400,
//             textAlign: 'center',
//             display: 'none',
//             '@media (max-width: 768px)': {
//               display: 'block',
//               order: -1,
//               width: '100%'
//             }
//           }}
//         >
//           Unlock Continuous Earnings with VYN's Recurring Revenue Program
//         </animated.h1>
        
//         {/* Right content */}
//         <div style={{ flex: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//           {/* Desktop title */}
//           <animated.h1 
//             style={{
//               ...desktopTitleAnimation,
//               position: 'relative',
//               zIndex: 1,
//               fontSize: '1.2rem',
//               color: 'white',
//               fontWeight: 500,
//               '@media (max-width: 768px)': {
//                 display: 'none'
//               }
//             }}
//           >
//             Unlock Continuous Earnings with VYN's Recurring Revenue Program
//           </animated.h1>
//           <animated.h1 
//             style={{
//               ...desktopTitleAnimation,
//               position: 'relative',
//               zIndex: 1,
//               fontSize: '1rem',
//               textAlign: "center",
//               opacity: 0.8,
//               color: 'white',
//               marginBottom: '40px',
//               fontWeight: 500,
//               '@media (max-width: 768px)': {
//                 display: 'none'
//               }
//             }}
//           >
//             Expand your reach and revenue by collaborating with VYN. Choose the partnership model that fits your strengths—whether it's referring, selling, or implementing—and start earning sustainable, predictable income.
//           </animated.h1>
          
//           {/* Cards slider container */}
//           <div style={{ position: 'relative', width: '100%' }}>
//             <animated.button 
//               onClick={scrollLeft}
//               style={{
//                 ...leftArrowAnimation,
//                 position: 'absolute',
//                 top: '50%',
//                 transform: 'translateY(-50%)',
//                 left: '10px',
//                 width: '40px',
//                 height: '40px',
//                 backgroundColor: 'rgba(255, 255, 255, 0.8)',
//                 border: '1px solid #ddd',
//                 borderRadius: '50%',
//                 fontSize: '1.2rem',
//                 cursor: 'pointer',
//                 zIndex: 10,
//                 display: 'none',
//                 '@media (max-width: 768px)': {
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }
//               }}
//             >
//               &lt;
//             </animated.button>
            
//             {/* Cards stack */}
//             <div 
//               ref={sliderRef}
//               style={{
//                 display: 'flex',
//                 gap: '15px',
//                 '@media (max-width: 768px)': {
//                   overflowX: 'auto',
//                   scrollSnapType: 'x mandatory',
//                   gap: '10px',
//                   WebkitOverflowScrolling: 'touch',
//                   scrollbarWidth: 'none'
//                 }
//               }}
//             >
//               {/* Render cards dynamically */}
//               {cardData.map((card, index) => {
//                 const cardAnimation = index === 0 ? card1Animation : index === 1 ? card2Animation : card3Animation;
                
//                 return (
//                   <animated.div 
//                     key={index}
//                     style={{
//                       ...cardAnimation,
//                       position: 'relative',
//                       zIndex: 1
//                     }}
//                   >
//                     <div style={{
//                       backgroundColor: 'white',
//                       borderRadius: '12px',
//                       padding: '24px',
//                       minWidth: '280px',
//                       height: '480px',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
//                       cursor: 'pointer',
//                       transition: 'transform 0.3s ease-in-out',
//                       border: '1px solid #e5e7eb',
//                       borderTop: '10px solid #1FE16F'
//                     }}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.transform = 'scale(1.05)';
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.transform = 'scale(1)';
//                     }}
//                     >
//                       <div style={{
//                         textAlign: 'center',
//                         paddingBottom: '16px',
//                         marginBottom: '0px'
//                       }}>
//                         <h3 style={{
//                           fontSize: '18px',
//                           fontWeight: 600,
//                           color: '#374151',
//                           margin: '0 0 12px 0',
//                           letterSpacing: '0.5px'
//                         }}>
//                           {card.title}
//                         </h3>
                        
//                         {/* Divider above percentage image */}
//                         <img 
//                           src={card.dividerImage} 
//                           alt="Divider" 
//                           style={{
//                             width: '100%',
//                             height: 'auto',
//                             margin: '8px 0'
//                           }}
//                         />
                        
//                         {/* Percentage image */}
//                         <img 
//                           src={card.percentageImage} 
//                           alt={`${card.title} percentage`} 
//                           style={{
//                             width: 'auto',
//                             height: '80px',
//                             margin: '8px 0',
//                             objectFit: 'contain'
//                           }}
//                         />
//                         <h4 style={{
//                           fontSize: '18px',
//                           fontWeight: 600,
//                           color: '#1f2937',
//                           margin: '8px 0 0 0'
//                         }}>
//                           {card.subtitle}
//                         </h4>
                        
//                         {/* Divider below percentage image */}
//                         <img 
//                           src={card.dividerImage} 
//                           alt="Divider" 
//                           style={{
//                             width: '100%',
//                             height: 'auto',
//                             margin: '8px 0'
//                           }}
//                         />
                        
                        
//                       </div>
                      
//                       <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
//                         <ul style={{
//                           listStyle: 'none',
//                           padding: 0,
//                           margin: '0 0 0px 0',
//                           flex: 1
//                         }}>
//                           {card.bulletPoints.map((point, pointIndex) => (
//                             <li key={pointIndex} style={{
//                               display: 'flex',
//                               alignItems: 'flex-start',
//                               marginBottom: '12px',
//                               fontSize: '14px',
//                               color: '#000000',
//                               lineHeight: '1.5'
//                             }}>
//                               <span style={{
//                                 color: '#8b5cf6',
//                                 marginRight: '8px',
//                                 fontSize: '16px',
//                                 fontWeight: 'bold',
//                                 marginTop: '2px'
//                               }}>▶</span>
//                               {point}
//                             </li>
//                           ))}
//                         </ul>
                        
//                         <button style={{
//                           backgroundColor: 'transparent',
//                           color: '#064771',
//                           border: '2px solid #064771',
//                           borderRadius: '6px',
//                           padding: '12px 24px',
//                           fontSize: '16px',
//                           fontWeight: 600,
//                           cursor: 'pointer',
//                           transition: 'all 0.3s ease',
//                           width: '100%',
//                           marginTop: 'auto'
//                         }}
//                         onMouseEnter={(e) => {
//                           e.target.style.backgroundColor = '#064771';
//                           e.target.style.color = 'white';
//                         }}
//                         onMouseLeave={(e) => {
//                           e.target.style.backgroundColor = 'transparent';
//                           e.target.style.color = '#064771';
//                         }}
//                         >
//                           Join Now
//                         </button>
//                       </div>
//                     </div>
//                   </animated.div>
//                 );
//               })}
//             </div>
            
//             <animated.button 
//               onClick={scrollRight}
//               style={{
//                 ...rightArrowAnimation,
//                 position: 'absolute',
//                 top: '50%',
//                 transform: 'translateY(-50%)',
//                 right: '10px',
//                 width: '40px',
//                 height: '40px',
//                 backgroundColor: 'rgba(255, 255, 255, 0.8)',
//                 border: '1px solid #ddd',
//                 borderRadius: '50%',
//                 fontSize: '1.2rem',
//                 cursor: 'pointer',
//                 zIndex: 10,
//                 display: 'none',
//                 '@media (max-width: 768px)': {
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }
//               }}
//             >
//               &gt;
//             </animated.button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReferralPartners;

// import React, { useRef, useEffect, useState } from 'react';
// import { useSpring, animated } from 'react-spring';
// import img1 from "../../img/des_sec/partner_img_1.svg";
// import img2 from "../../img/des_sec/partner_img_2.svg";
// import img3 from "../../img/des_sec/partner_img_3.svg";
// import divider from "../../img/des_sec/divider_partner.svg";

// const ReferralPartners = ({openPartnerModal}) => {
//   const [inView, setInView] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const containerRef = useRef(null);
//   const sliderRef = useRef(null);

//   // Check for mobile screen size
//   useEffect(() => {
//     const checkScreenSize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };

//     checkScreenSize();
//     window.addEventListener('resize', checkScreenSize);
    
//     return () => window.removeEventListener('resize', checkScreenSize);
//   }, []);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setInView(true);
//         } else {
//           setInView(false);
//         }
//       },
//       {
//         threshold: 0.2,
//         rootMargin: '-50px 0px'
//       }
//     );

//     if (containerRef.current) {
//       observer.observe(containerRef.current);
//     }

//     return () => {
//       if (containerRef.current) {
//         observer.unobserve(containerRef.current);
//       }
//     };
//   }, []);

//   const scrollLeft = () => {
//     if (sliderRef.current) {
//       sliderRef.current.scrollBy({ left: -280, behavior: 'smooth' });
//     }
//   };

//   const scrollRight = () => {
//     if (sliderRef.current) {
//       sliderRef.current.scrollBy({ left: 280, behavior: 'smooth' });
//     }
//   };

//   // Animation configurations
//   const blueHeaderAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(-15px)',
//     config: { tension: 200, friction: 40, mass: 1 },
//     delay: inView ? 100 : 0
//   });

//   const mobileTitleAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(20px)',
//     config: { tension: 180, friction: 35, mass: 1 },
//     delay: inView ? 200 : 0
//   });

//   const leftIllustrationAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-30px) scale(0.95)',
//     config: { tension: 160, friction: 30, mass: 1.2 },
//     delay: inView ? 300 : 0
//   });

//   const desktopTitleAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px)' : 'translateY(20px)',
//     config: { tension: 180, friction: 35, mass: 1 },
//     delay: inView ? 400 : 0
//   });

//   const leftArrowAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-10px) scale(0.9)',
//     config: { tension: 150, friction: 25, mass: 0.8 },
//     delay: inView ? 500 : 0
//   });

//   const rightArrowAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateX(0px) scale(1)' : 'translateX(10px) scale(0.9)',
//     config: { tension: 150, friction: 25, mass: 0.8 },
//     delay: inView ? 500 : 0
//   });

//   const card1Animation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
//     config: { tension: 140, friction: 25, mass: 0.9 },
//     delay: inView ? 600 : 0
//   });

//   const card2Animation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
//     config: { tension: 140, friction: 25, mass: 0.9 },
//     delay: inView ? 750 : 0
//   });

//   const card3Animation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
//     config: { tension: 140, friction: 25, mass: 0.9 },
//     delay: inView ? 900 : 0
//   });

//   // Card data - Add your image paths here
//   const cardData = [
//     {
//       title: "REFERRAL PARTNER",
//       percentageImage: img1, // Replace with your image path
//       dividerImage: divider, // Replace with your divider image path
//       subtitle: "Recurring Income",
//       bulletPoints: [
//         "You refer leads; VYN manages sales and implementation",
//         "ZERO investment required",
//         "Ideal for: Consultants, Industry Experts, Network Connectors"
//       ]
//     },
//     {
//       title: "SALES PARTNER",
//       percentageImage: img2, // Replace with your image path
//       dividerImage: divider, // Replace with your divider image path
//       subtitle: "Recurring Income",
//       bulletPoints: [
//         "You generate leads and close sales; VYN handles implementation",
//         "Perfect for: Consultancy Firms, IT Resellers",
//       ]
//     },
//     {
//       title: "IMPLEMENTATION PARTNER",
//       percentageImage: img3, // Replace with your image path
//       dividerImage: divider, // Replace with your divider image path
//       subtitle: "Recurring Income",
//       bulletPoints: [
//         "You implement VYN for your clients with full support from us",
//         "Perfect for: IT Service Providers, Workforce Tech Specialists",
//       ]
//     }
//   ];

//   return (
//     <div style={{ position: 'relative', width: '100%', overflow: 'hidden' }} ref={containerRef}>
//       <animated.div 
//         style={{
//           ...blueHeaderAnimation,
//           position: 'relative',
//           zIndex: 1,
//           width: '100%',
//           backgroundColor: 'white',
//           fontSize: '18px',
//           color: '#04426B',
//           textAlign: 'center',
//           padding: '1.5rem 0',
//           boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)'
//         }}
//       >
//         <h1 style={{ margin: 0, fontSize: isMobile ? '24px' : '28px', fontWeight: 600 }}>Partner Model</h1>
//       </animated.div>
      
//       <div style={{
//         position: 'absolute',
//         left: 0,
//         width: '100%',
//         height: '50%',
//         background: 'linear-gradient(135deg, #096BAA 0%, #06436B 100%)',
//         zIndex: -1
//       }}></div>
      
//       <div style={{
//         display: 'flex',
//         margin: isMobile ? '0 10px' : '0 20px',
//         padding: isMobile ? '20px 15px' : '40px 40px',
//         gap: isMobile ? '20px' : '60px',
//         alignItems: 'center',
//         flexDirection: isMobile ? 'column' : 'row'
//       }}>
//         {/* Mobile title */}
//         {isMobile && (
//           <>
//             <animated.h1 
//               style={{
//                 ...mobileTitleAnimation,
//                 position: 'relative',
//                 zIndex: 1,
//                 fontSize: '1.5rem',
//                 color: 'white',
//                 marginBottom: '0px',
//                 fontWeight: 500,
//                 textAlign: 'center',
//                 width: '100%',
//                 order: -1
//               }}
//             >
//               Unlock Continuous Earnings with VYN's Recurring Revenue Program
//             </animated.h1>
//             <animated.h1 
//               style={{
//                 ...mobileTitleAnimation,
//                 position: 'relative',
//                 zIndex: 1,
//                 fontSize: '1rem',
//                 color: 'white',
//                 marginBottom: '20px',
//                 fontWeight: 400,
//                 textAlign: 'center',
//                 width: '100%',
//                 order: -1
//               }}
//             >
//               Earn lucrative commissions tailored to client profile, and geography.
//             </animated.h1>
//           </>
//         )}
        
//         {/* Right content */}
//         <div style={{ flex: 5, display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
//           {/* Desktop title */}
//           {!isMobile && (
//             <>
//               <animated.h1 
//                 style={{
//                   ...desktopTitleAnimation,
//                   position: 'relative',
//                   zIndex: 1,
//                   fontSize: '1.2rem',
//                   color: 'white',
//                   fontWeight: 500
//                 }}
//               >
//                 Unlock Continuous Earnings with VYN's Recurring Revenue Program
//               </animated.h1>
//               <animated.h1 
//                 style={{
//                   ...desktopTitleAnimation,
//                   position: 'relative',
//                   zIndex: 1,
//                   fontSize: '1rem',
//                   textAlign: "center",
//                   opacity: 0.8,
//                   color: 'white',
//                   marginBottom: '40px',
//                   fontWeight: 500
//                 }}
//               >
//                 Earn lucrative commissions tailored to client profile, and geography.
//               </animated.h1>
//             </>
//           )}
          
//           {/* Cards slider container */}
//           <div style={{ position: 'relative', width: '100%' }}>
//             {isMobile && (
//               <animated.button 
//                 onClick={scrollLeft}
//                 style={{
//                   ...leftArrowAnimation,
//                   position: 'absolute',
//                   top: '50%',
//                   transform: 'translateY(-50%)',
//                   left: '10px',
//                   width: '40px',
//                   height: '40px',
//                   backgroundColor: 'rgba(255, 255, 255, 0.8)',
//                   border: '1px solid #ddd',
//                   borderRadius: '50%',
//                   fontSize: '1.2rem',
//                   cursor: 'pointer',
//                   zIndex: 10,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }}
//               >
//                 &lt;
//               </animated.button>
//             )}
            
//             {/* Cards stack */}
//             <div 
//               ref={sliderRef}
//               style={{
//                 display: 'flex',
//                 gap: isMobile ? '10px' : '15px',
//                 overflowX: isMobile ? 'auto' : 'visible',
//                 scrollSnapType: isMobile ? 'x mandatory' : 'none',
//                 WebkitOverflowScrolling: isMobile ? 'touch' : 'auto',
//                 scrollbarWidth: isMobile ? 'none' : 'auto',
//                 msOverflowStyle: isMobile ? 'none' : 'auto',
//                 paddingBottom: isMobile ? '10px' : '0'
//               }}
//               className={isMobile ? 'mobile-scroll' : ''}
//             >
//               {/* Hide scrollbar for mobile */}
//               <style jsx>{`
//                 .mobile-scroll::-webkit-scrollbar {
//                   display: none;
//                 }
//               `}</style>
              
//               {/* Render cards dynamically */}
//               {cardData.map((card, index) => {
//                 const cardAnimation = index === 0 ? card1Animation : index === 1 ? card2Animation : card3Animation;
                
//                 return (
//                   <animated.div 
//                     key={index}
//                     style={{
//                       ...cardAnimation,
//                       position: 'relative',
//                       zIndex: 1,
//                       scrollSnapAlign: isMobile ? 'start' : 'none'
//                     }}
//                   >
//                     <div style={{
//                       backgroundColor: 'white',
//                       borderRadius: '12px',
//                       padding: isMobile ? '20px' : '24px',
//                       minWidth: isMobile ? '260px' : '280px',
//                       height: isMobile ? '450px' : '480px',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
//                       cursor: 'pointer',
//                       transition: 'transform 0.3s ease-in-out',
//                       border: '1px solid #e5e7eb',
//                       borderTop: '10px solid #1FE16F'
//                     }}
//                     onMouseEnter={(e) => {
//                       if (!isMobile) {
//                         e.currentTarget.style.transform = 'scale(1.05)';
//                       }
//                     }}
//                     onMouseLeave={(e) => {
//                       if (!isMobile) {
//                         e.currentTarget.style.transform = 'scale(1)';
//                       }
//                     }}
//                     >
//                       <div style={{
//                         textAlign: 'center',
//                         paddingBottom: '16px',
//                         marginBottom: '0px'
//                       }}>
//                         <h3 style={{
//                           fontSize: isMobile ? '16px' : '18px',
//                           fontWeight: 600,
//                           color: '#374151',
//                           margin: '0 0 12px 0',
//                           letterSpacing: '0.5px'
//                         }}>
//                           {card.title}
//                         </h3>
                        
//                         {/* Divider above percentage image */}
//                         <img 
//                           src={card.dividerImage} 
//                           alt="Divider" 
//                           style={{
//                             width: '100%',
//                             height: 'auto',
//                             margin: '8px 0'
//                           }}
//                         />
                        
//                         {/* Percentage image */}
//                         <img 
//                           src={card.percentageImage} 
//                           alt={`${card.title} percentage`} 
//                           style={{
//                             width: 'auto',
//                             height: isMobile ? '70px' : '80px',
//                             margin: '8px 0',
//                             objectFit: 'contain'
//                           }}
//                         />
//                         {/* <h4 style={{
//                           fontSize: isMobile ? '16px' : '18px',
//                           fontWeight: 600,
//                           color: '#1f2937',
//                           margin: '8px 0 0 0'
//                         }}>
//                           {card.subtitle}
//                         </h4>
//                          */}
//                         {/* Divider below percentage image */}
//                         <img 
//                           src={card.dividerImage} 
//                           alt="Divider" 
//                           style={{
//                             width: '100%',
//                             height: 'auto',
//                             margin: '8px 0'
//                           }}
//                         />
//                       </div>
                      
//                       <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
//                         <ul style={{
//                           listStyle: 'none',
//                           padding: 0,
//                           margin: '0 0 0px 0',
//                           flex: 1
//                         }}>
//                           {card.bulletPoints.map((point, pointIndex) => (
//                             <li key={pointIndex} style={{
//                               display: 'flex',
//                               alignItems: 'flex-start',
//                               marginBottom: '12px',
//                               fontSize: isMobile ? '13px' : '14px',
//                               color: '#000000',
//                               lineHeight: '1.5'
//                             }}>
//                               <span style={{
//                                 color: '#8b5cf6',
//                                 marginRight: '8px',
//                                 fontSize: isMobile ? '14px' : '16px',
//                                 fontWeight: 'bold',
//                                 marginTop: '2px'
//                               }}>▶</span>
//                               {point}
//                             </li>
//                           ))}
//                         </ul>
                        
//                         <button style={{
//                           backgroundColor: 'transparent',
//                           color: '#064771',
//                           border: '2px solid #064771',
//                           borderRadius: '6px',
//                           padding: isMobile ? '10px 20px' : '12px 24px',
//                           fontSize: isMobile ? '14px' : '16px',
//                           fontWeight: 600,
//                           cursor: 'pointer',
//                           transition: 'all 0.3s ease',
//                           width: '100%',
//                           marginTop: 'auto'
//                         }}
//                         onClick={openPartnerModal}
//                         onMouseEnter={(e) => {
//                           e.target.style.backgroundColor = '#064771';
//                           e.target.style.color = 'white';
//                         }}
//                         onMouseLeave={(e) => {
//                           e.target.style.backgroundColor = 'transparent';
//                           e.target.style.color = '#064771';
//                         }}
//                         >
//                           Join Now
//                         </button>
//                       </div>
//                     </div>
//                   </animated.div>
//                 );
//               })}
//             </div>
            
//             {isMobile && (
//               <animated.button 
//                 onClick={scrollRight}
//                 style={{
//                   ...rightArrowAnimation,
//                   position: 'absolute',
//                   top: '50%',
//                   transform: 'translateY(-50%)',
//                   right: '10px',
//                   width: '40px',
//                   height: '40px',
//                   backgroundColor: 'rgba(255, 255, 255, 0.8)',
//                   border: '1px solid #ddd',
//                   borderRadius: '50%',
//                   fontSize: '1.2rem',
//                   cursor: 'pointer',
//                   zIndex: 10,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }}
//               >
//                 &gt;
//               </animated.button>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReferralPartners;

import React, { useRef, useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import img1 from "../../img/des_sec/partner_img_1.svg";
import img2 from "../../img/des_sec/partner_img_2.svg";
import img3 from "../../img/des_sec/partner_img_3.svg";
import divider from "../../img/des_sec/divider_partner.svg";

const ReferralPartners = ({openPartnerModal}) => {
  const [inView, setInView] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const containerRef = useRef(null);
  const sliderRef = useRef(null);

  // Check for mobile screen size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        } else {
          setInView(false);
        }
      },
      {
        threshold: 0.2,
        rootMargin: '-50px 0px'
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -280, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 280, behavior: 'smooth' });
    }
  };

  // Animation configurations
  const blueHeaderAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(-15px)',
    config: { tension: 200, friction: 40, mass: 1 },
    delay: inView ? 100 : 0
  });

  const mobileTitleAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(20px)',
    config: { tension: 180, friction: 35, mass: 1 },
    delay: inView ? 200 : 0
  });

  const leftIllustrationAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-30px) scale(0.95)',
    config: { tension: 160, friction: 30, mass: 1.2 },
    delay: inView ? 300 : 0
  });

  const desktopTitleAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(20px)',
    config: { tension: 180, friction: 35, mass: 1 },
    delay: inView ? 400 : 0
  });

  const leftArrowAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-10px) scale(0.9)',
    config: { tension: 150, friction: 25, mass: 0.8 },
    delay: inView ? 500 : 0
  });

  const rightArrowAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px) scale(1)' : 'translateX(10px) scale(0.9)',
    config: { tension: 150, friction: 25, mass: 0.8 },
    delay: inView ? 500 : 0
  });

  const card1Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
    config: { tension: 140, friction: 25, mass: 0.9 },
    delay: inView ? 600 : 0
  });

  const card2Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
    config: { tension: 140, friction: 25, mass: 0.9 },
    delay: inView ? 750 : 0
  });

  const card3Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
    config: { tension: 140, friction: 25, mass: 0.9 },
    delay: inView ? 900 : 0
  });

  const footerTextAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(20px)',
    config: { tension: 140, friction: 25, mass: 0.9 },
    delay: inView ? 1000 : 0
  });

  // Card data
  const cardData = [
    {
      title: "REFERRAL PARTNER",
      percentageImage: img1,
      dividerImage: divider,
      subtitle: "Recurring Income",
      bulletPoints: [
        "You refer leads; VYN manages sales and implementation",
        "ZERO investment required",
        "Ideal for: Consultants, Industry Experts, Network Connectors"
      ]
    },
    {
      title: "SALES PARTNER",
      percentageImage: img2,
      dividerImage: divider,
      subtitle: "Recurring Income",
      bulletPoints: [
        "You generate leads and close sales; VYN handles implementation",
        "Perfect for: Consultancy Firms, IT Resellers",
      ]
    },
    {
      title: "IMPLEMENTATION PARTNER",
      percentageImage: img3,
      dividerImage: divider,
      subtitle: "Recurring Income",
      bulletPoints: [
        "You implement VYN for your clients with full support from us",
        "Perfect for: IT Service Providers, Workforce Tech Specialists",
      ]
    }
  ];

  return (
    <div style={{ position: 'relative', width: '100%', overflow: 'hidden' }} ref={containerRef}>
      <animated.div 
        style={{
          ...blueHeaderAnimation,
          position: 'relative',
          zIndex: 1,
          width: '100%',
          backgroundColor: 'white',
          fontSize: '18px',paddingTop:"10px",
          color: '#04426B',
          textAlign: 'center',
          padding: '1.3rem 0',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)'
        }}
      >
        <h1 style={{ margin: 0, fontSize: isMobile ? '24px' : '28px', fontWeight: 600 }}>Partner Model</h1>
      </animated.div>
      
      <div style={{
        position: 'absolute',
        left: 0,
        width: '100%',
        height: '50%',
        background: 'linear-gradient(135deg, #096BAA 0%, #06436B 100%)',
        zIndex: -1
      }}></div>
      
      <div style={{
        display: 'flex',
        margin: isMobile ? '0 10px' : '0 20px',
        padding: isMobile ? '0px' : '40px 40px',
        gap: isMobile ? '20px' : '60px',
        alignItems: 'center',
        flexDirection: isMobile ? 'column' : 'row'
      }}>
        {/* Mobile title */}
        {isMobile && (
          <>
            <animated.h1 
              style={{
                ...mobileTitleAnimation,
                position: 'relative',
                zIndex: 1,
                fontSize: '1.5rem',
                color: 'white',
                marginBottom: '0px',paddingTop:"10px",
                fontWeight: 500,
                textAlign: 'center',
                width: '100%',
                order: -1
              }}
            >
              Unlock Continuous Earnings with VYN's Recurring Revenue Program
            </animated.h1>
            {/* <animated.h1 
              style={{
                ...mobileTitleAnimation,
                position: 'relative',
                zIndex: 1,
                fontSize: '1rem',
                color: 'white',
                marginBottom: '20px',
                fontWeight: 400,
                textAlign: 'center',
                width: '100%',
                order: -1
              }}
            >
              Earn lucrative commissions tailored to client profile, and geography.
            </animated.h1> */}
          </>
        )}
        
        {/* Right content */}
        <div style={{ flex: 5, display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
          {/* Desktop title */}
          {!isMobile && (
            <>
              <animated.h1 
                style={{
                  ...desktopTitleAnimation,
                  position: 'relative',
                  zIndex: 1,
                  fontSize: '1.2rem',
                  color: 'white',
                  fontWeight: 500,paddingBottom:"20px"
                }}
              >
                Unlock Continuous Earnings with VYN's Recurring Revenue Program
              </animated.h1>
              {/* <animated.h1 
                style={{
                  ...desktopTitleAnimation,
                  position: 'relative',
                  zIndex: 1,
                  fontSize: '1rem',
                  textAlign: "center",
                  opacity: 0.8,
                  color: 'white',
                  marginBottom: '40px',
                  fontWeight: 500
                }}
              >
                Earn lucrative commissions tailored to client profile, and geography.
              </animated.h1> */}
            </>
          )}
          
          {/* Cards slider container */}
          <div style={{ position: 'relative', width: '100%' }}>
            {/* {isMobile && (
              <animated.button 
                onClick={scrollLeft}
                style={{
                  ...leftArrowAnimation,
                  position: 'absolute',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  left: '10px',
                  width: '40px',
                  height: '40px',
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  border: '1px solid #ddd',
                  borderRadius: '50%',
                  fontSize: '1.2rem',
                  cursor: 'pointer',
                  zIndex: 10,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                &lt;
              </animated.button>
            )} */}
            
            {/* Cards stack */}
            <div 
              ref={sliderRef}
              style={{
                display: 'flex',
                gap: isMobile ? '10px' : '15px',
                overflowX: isMobile ? 'auto' : 'visible',
                scrollSnapType: isMobile ? 'x mandatory' : 'none',
                WebkitOverflowScrolling: isMobile ? 'touch' : 'auto',
                scrollbarWidth: isMobile ? 'none' : 'auto',
                msOverflowStyle: isMobile ? 'none' : 'auto',
                paddingBottom: isMobile ? '10px' : '0'
              }}
              className={isMobile ? 'mobile-scroll' : ''}
            >
              {/* Hide scrollbar for mobile */}
              <style jsx>{`
                .mobile-scroll::-webkit-scrollbar {
                  display: none;
                }
              `}</style>
              
              {/* Render cards dynamically */}
              {cardData.map((card, index) => {
                const cardAnimation = index === 0 ? card1Animation : index === 1 ? card2Animation : card3Animation;
                
                return (
                  <animated.div 
                    key={index}
                    style={{
                      ...cardAnimation,
                      position: 'relative',
                      marginRight:"10px",
                      zIndex: 1,
                      scrollSnapAlign: isMobile ? 'start' : 'none'
                    }}
                  >
                    <div style={{
                      backgroundColor: 'white',
                      borderRadius: '12px',
                      padding: isMobile ? '20px' : '24px',
                      minWidth: isMobile ? '300px' : '280px',
                      height: isMobile ? '450px' : '480px',
                      display: 'flex',
                      flexDirection: 'column',
                      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease-in-out',
                      border: '1px solid #e5e7eb',
                      borderTop: '10px solid #1FE16F'
                    }}
                    onMouseEnter={(e) => {
                      if (!isMobile) {
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isMobile) {
                        e.currentTarget.style.transform = 'scale(1)';
                      }
                    }}
                    >
                      <div style={{
                        textAlign: 'center',
                        paddingBottom: '16px',
                        marginBottom: '0px'
                      }}>
                        <h3 style={{
                          fontSize: isMobile ? '16px' : '18px',
                          fontWeight: 600,
                          color: '#374151',
                          margin: '0 0 12px 0',
                          letterSpacing: '0.5px'
                        }}>
                          {card.title}
                        </h3>
                        
                        {/* Divider above percentage image */}
                        <img 
                          src={card.dividerImage} 
                          alt="Divider" 
                          style={{
                            width: '100%',
                            height: 'auto',
                            margin: '8px 0'
                          }}
                        />
                        
                        {/* Percentage image */}
                        <img 
                          src={card.percentageImage} 
                          alt={`${card.title} percentage`} 
                          style={{
                            width: 'auto',
                            height: isMobile ? '70px' : '80px',
                            margin: '8px 0',
                            objectFit: 'contain'
                          }}
                        />
                        
                        {/* Divider below percentage image */}
                        <img 
                          src={card.dividerImage} 
                          alt="Divider" 
                          style={{
                            width: '100%',
                            height: 'auto',
                            margin: '8px 0'
                          }}
                        />
                      </div>
                      
                      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <ul style={{
                          listStyle: 'none',
                          padding: 0,
                          margin: '0 0 0px 0',
                          flex: 1
                        }}>
                          {card.bulletPoints.map((point, pointIndex) => (
                            <li key={pointIndex} style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              marginBottom: '12px',
                              fontSize: isMobile ? '13px' : '14px',
                              color: '#000000',
                              lineHeight: '1.5'
                            }}>
                              <span style={{
                                color: '#8b5cf6',
                                marginRight: '8px',
                                fontSize: isMobile ? '14px' : '16px',
                                fontWeight: 'bold',
                                marginTop: '2px'
                              }}>▶</span>
                              {point}
                            </li>
                          ))}
                        </ul>
                        
                        <button style={{
                          backgroundColor: 'transparent',
                          color: '#064771',
                          border: '2px solid #064771',
                          borderRadius: '6px',
                          padding: isMobile ? '10px 20px' : '12px 24px',
                          fontSize: isMobile ? '14px' : '16px',
                          fontWeight: 600,
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          width: '100%',
                          marginTop: 'auto'
                        }}
                        onClick={openPartnerModal}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#064771';
                          e.target.style.color = 'white';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = 'transparent';
                          e.target.style.color = '#064771';
                        }}
                        >
                          Join Now
                        </button>
                      </div>
                    </div>
                  </animated.div>
                );
              })}
            </div>
            
            {/* {isMobile && (
              <animated.button 
                onClick={scrollRight}
                style={{
                  ...rightArrowAnimation,
                  position: 'absolute',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  right: '10px',
                  width: '40px',
                  height: '40px',
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  border: '1px solid #ddd',
                  borderRadius: '50%',
                  fontSize: '1.2rem',
                  cursor: 'pointer',
                  zIndex: 10,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                &gt;
              </animated.button>
            )} */}
          </div>
          
          {/* Footer text below cards */}
          <animated.div 
            style={{
              ...footerTextAnimation,
              textAlign: 'center',
              fontSize: isMobile ? '0.9rem' : '1rem',
              color: '#064771',
              fontWeight: 400,
              marginTop: isMobile ? '20px' : '30px',
              fontFamily: '"Noto Serif", serif',
              padding: '15px 20px'
            }}
          >
            Commissions may vary by client profile and region. Contact us for details.
          </animated.div>
        </div>
      </div>
    </div>
  );
};

export default ReferralPartners;